import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { PaperPlaneTilt } from "@phosphor-icons/react";

export default function Newsletter({ compact = false }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      const res = await api.subscribe(email);
      toast.success(res.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error("Something went wrong. Try again shortly.");
    } finally {
      setLoading(false);
    }
  };

  if (compact) {
    return (
      <form onSubmit={submit} data-testid="newsletter-form-compact" className="w-full">
        <label className="overline block mb-2">The Finance Topia Weekly</label>
        <div className="flex border border-foreground/30 focus-within:border-foreground">
          <input
            data-testid="newsletter-email-compact"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            className="flex-1 bg-transparent px-3 h-11 text-sm outline-none"
            required
          />
          <button
            data-testid="newsletter-submit-compact"
            disabled={loading}
            className="px-4 bg-foreground text-background text-sm font-semibold hover:bg-primary transition-colors duration-200 disabled:opacity-60"
          >
            {loading ? "..." : "Join"}
          </button>
        </div>
        <p className="text-[11px] text-foreground/50 mt-2">
          Weekly market briefing. Unsubscribe anytime. <a href="/privacy" className="underline hover:text-primary">Privacy</a>.
        </p>
      </form>
    );
  }

  return (
    <section
      data-testid="newsletter-section"
      className="border-y-2 border-foreground/80 my-16 py-14"
    >
      <div className="max-w-3xl mx-auto text-center px-4">
        <div className="overline">Free Weekly Newsletter</div>
        <h2 className="font-display text-4xl sm:text-5xl font-black mt-4 leading-tight tracking-tight">
          The Finance Topia Weekly.
          <span className="italic font-normal"> One email. Every Sunday.</span>
        </h2>
        <p className="mt-4 text-foreground/70 max-w-xl mx-auto">
          Markets, macro, and money — decoded into a 5-minute Sunday read. Written by
          our CFA-trained editors. No spam. No hype.
        </p>
        <form onSubmit={submit} className="mt-8 flex max-w-lg mx-auto border-2 border-foreground focus-within:bg-foreground/[0.02]">
          <input
            data-testid="newsletter-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="flex-1 bg-transparent px-4 h-14 outline-none"
            required
          />
          <button
            data-testid="newsletter-submit"
            disabled={loading}
            className="px-6 bg-foreground text-background font-semibold hover:bg-primary transition-colors duration-200 disabled:opacity-60 inline-flex items-center gap-2"
          >
            <PaperPlaneTilt size={16} weight="bold" />
            {loading ? "Subscribing..." : "Subscribe Free"}
          </button>
        </form>
        <p className="text-xs text-foreground/50 mt-3 font-mono">
          Join 12,000+ readers. Editorial content only, not investment advice.
        </p>
      </div>
    </section>
  );
}
